var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "f2cc10e724445353ead7a4a0fbb042d77e2028bc"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["ouronyx@ouronyx"] = {
  id: "f2cc10e724445353ead7a4a0fbb042d77e2028bc"
};